var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwoLabel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46.533,
    height: 45.774,
    viewBox: "0 0 46.533 45.774",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_22508",
    "data-name": "Group 22508",
    transform: "translate(-135.423 -475.616)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21683",
    "data-name": "Group 21683",
    transform: "translate(135.423 475.616)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50766",
    "data-name": "Path 50766",
    d: "M151.507,468.253c6.273-.014,12.532-.15,18.8-.45l2.345-.123c5.059.273,9.791-4.214,9.232-9.218-.518-7.036-1-14.1-1.309-21.15a7.03,7.03,0,0,0-6.845-7.582q-9.409,0-18.8-.436l-2.345-.123a7.867,7.867,0,0,0-9.218,7.05c-.464,6.273-.886,12.532-1.2,18.8-.027,1.555-.232,3.164-.109,4.664a9.563,9.563,0,0,0,9.45,8.564Zm0,0a10.183,10.183,0,0,1-9.954-8.5c-.218-1.623-.191-3.15-.286-4.732-.314-6.273-.736-12.532-1.2-18.8a11.809,11.809,0,0,1,4.527-9.914,13.111,13.111,0,0,1,8.018-2.618l2.345-.123q9.409-.45,18.8-.436A12.923,12.923,0,0,1,186.5,437.3l-.109,2.345c-.314,6.273-.736,12.532-1.2,18.8a11.542,11.542,0,0,1-1.6,5.127,11.126,11.126,0,0,1-10.909,5.236l-2.345-.123c-6.3-.273-12.559-.423-18.832-.436Z",
    transform: "translate(-140.044 -423.129)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("text", {
    id: "_2",
    "data-name": 2,
    transform: "translate(153.402 508.496)",
    fill: "#fff",
    fontSize: 25,
    fontFamily: "Helvetica"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "2")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwoLabel);
export default __webpack_public_path__ + "static/media/two_label.e7aa948265eda79c215a3393bfce77a3.svg";
export { ForwardRef as ReactComponent };